import styled from "styled-components"
import { device } from "breakpoints"

export const CTAContainer = styled.div`
  background: ${props => props.theme[props.color][0]};

  padding: 50px 0 40px 0;
  margin-top: 60px;

  @media ${device.desktop} {
    padding: 90px 0 75px 0;
    margin-top: 90px;
  }

  h2 {
    font-size: 24px;
    margin-bottom: 22px;

    @media ${device.desktop} {
      font-size: 30px;
      margin-bottom: 0px;
    }
  }

  p {
    font-size: 24px;

    @media ${device.desktop} {
      font-size: 30px;
      line-height: 140%;
    }

    a {
      background-image: linear-gradient(to right, black, black);
      background-position: 0 97%;
      background-repeat: no-repeat;
      background-size: 100% 2px;
      background-color: white;
      font-weight: 600;
      padding: 3px;
    }
  }
`
